const hlxLogoAlt = require('./assets/hlx-logo-alt.jpg');

export default {
  sobix: {
    clientName: 'HELIX',
    customHeaderLogo: hlxLogoAlt
  }
};
